import p from "classnames";
import { lighten as N } from "polished";
import { root as f, inactiveCard as b, image as g, info as v, title as w, description as x, buttonLink as k, buttonIcon as y, visuallyHidden as C } from "./CardProductItem.css.js";
import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { Icon as I } from "../icon/Icon.js";
function U(i) {
  const {
    element: l,
    children: s,
    className: c,
    attributes: n,
    isActive: m
  } = i, {
    customAttributes: d,
    title: e,
    subtitle: u,
    url: h,
    imageUrl: t,
    arrowColor: a
  } = l;
  return /* @__PURE__ */ o("a", {
    ...d,
    href: h,
    target: "_blank",
    rel: "noopener noreferrer",
    className: p(f, {
      [b]: !m
    }, c),
    ...n,
    children: [t ? /* @__PURE__ */ r("img", {
      className: g,
      alt: e,
      src: t
    }) : null, /* @__PURE__ */ o("div", {
      className: v,
      children: [/* @__PURE__ */ r("h3", {
        className: w,
        children: e
      }), /* @__PURE__ */ r("p", {
        className: x,
        children: u
      })]
    }), /* @__PURE__ */ r("div", {
      className: k,
      style: {
        "--arrow-color": a,
        "--arrow-background-color": N(0.5, a)
      },
      children: /* @__PURE__ */ r(I, {
        className: y,
        type: "bx",
        name: "right-arrow-alt"
      })
    }), /* @__PURE__ */ r("div", {
      className: C,
      children: s
    })]
  });
}
export {
  U as CardProductItem
};
